 <template>
	<div>
		<el-drawer
			:title="name+'座位号导入'"
			:visible.sync="drawerShow"
			:wrapperClosable="false"
			:destroy-on-close="true"
			size="auto"
			@close="close"
		>
			<div class="drawer-content">
				<div class="temp-head clearfix">
					<div class="font16 MB20">1、请先下载赠票座位号导入表，在表格中填写每个兑换码对应的座位号</div>
					<el-button type="primary" @click="download()" size="small" :loading="downLoading">下载座位号导入表</el-button>					
				</div>                            
				<div class="temp-head clearfix MT20">
					<div class="font16 MB20">2、选择场次上传填写好的兑换码座位号。</div>
					
						<div class="MT20">
							<el-upload
								action
								:http-request="uploadExcel"
								:auto-upload="false"
								ref="upload"
								accept=".xls, .xlsx"
								:show-file-list="true"
								:before-upload="beforeUpload"
								:file-list="fileList"
								:on-change="onChange"
								:on-remove="onRemove"
								:disabled="uploadLoading"
								style="width:100%">
								<el-button size="small" style="float: left;" type="primary" :loading="uploadLoading">{{uploadLoading ? '上传中' : '上传座位号导入表'}}</el-button>
							</el-upload>
						</div>
						<div class="download color-blue MT20" v-if="data && data.siteFileUrl" style="cursor: pointer;" @click="downloadExcel(data.siteFileUrl)">
							{{name}} 座位号表.excel
						</div>
						<div v-if="MsgText"  class="MT20" >
							<el-alert show-icon type="error" v-if="MsgText" :closable="false">
								<div slot="title">上传失败：{{MsgText}}</div>
							</el-alert>
						</div>
						
				</div>				
				<div class="MT20">                    
					<div class="font16">3、请选择座位号展示时间</div>				
					<el-radio-group v-model="buildTime">
						<div class="MT20"><el-radio :label="0">演出开始前1天展示</el-radio></div>
						<div class="MT20"><el-radio :label="1">演出开始当天0点展示</el-radio></div>
						<div class="MT20"><el-radio :label="2">演出开始前6个小时展示</el-radio></div>
						<div class="MT20"><el-radio :label="3">创建后立即生成展示</el-radio></div>
					</el-radio-group>
					<small><div class="color-danger MT20">说明:演出开始前半个小时以前才可以导入座位号<br>只有导入下载的标准格式座位表才会生效<br>上传新的座位号表会盖原来的座位号</div></small>
				</div>                
			</div>
			<div class="drawer-footer">
			    <el-button v-if="!btnLoading" @click="close">取消</el-button>
			    <el-button type="primary" @click="onSubmit" :loading="btnLoading" :disabled="canSubmit"
			        >提交</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import {downloadFileTmp,uploadFileTmp} from '@/assets/js/commonApi.js';


export default {
    props:{
        activityId:{
            type:[Number,String],
            default:1
        },
        isSeat: {
            type:[Number,String],
            default: 0
        }
    },
    data() {
        return {
            drawerShow:false,
            btnLoading:false,
            downLoading:false,
            uploadLoading:false,         
            fileList:[],
            id:'',
            name:'',
            buildTime:3,
            data:{},            
            filePath:'',
            fileFullPath:'',
            MsgText:'',
			
			
			canSubmit:true,
        };
    },
    components:{},
    methods: {
        show(data) {			
        	this.data = data			
            this.id = data.id;
            this.name = data.ticketName
			this.buildTime = this.data && this.data.buildTime || this.data.buildTime == 0 ? this.data.buildTime : 3
            this.drawerShow = true;        	
        },
        close(){            
            this.drawerShow = false;
			this.sessionIds = '';
            this.errorData = [];
			this.MsgText = ''
			this.canSubmit = false;
			this.btnLoading = false;
			this.fileList = []
        },
		async downloadExcel(item){
		    const _item = item;		    
			await downloadFileTmp(_item, this.name + '座位号导入表.' + this.$utils.getFileType(_item));		   
		},
		//下载模板
		download(){
			let filePath;
			this.downLoading = true;			
			this.$request({
				url: '/activity/downloadSite',
				method: 'POST',
				params: {ticketPriceId:this.id } ,
			}).then(res => {
				const { state, msg, result } = res.data;
				if( state == 1 && result ){
					filePath = result.url;					
					downloadFileTmp(filePath,`座位号.`+this.$utils.getFileType(filePath));
					this.downLoading = false;					
				}else{
					this.downLoading = false;					
					return this.$message.error(msg || '下载失败');
				}
			}).catch(() => {
				this.$message.error('请求错误');
			}).finally(() => {				
				this.downLoading = false;
			});
		},
		onSubmit(){			
			this.$refs.upload.submit();
		},
		async uploadExcel(req){
		    this.btnLoading = true;
		    this.uploadLoading = true;
		    const formData = new FormData();
		    formData.append('file', req.file);
		
		    let filePath;
		    const res = await uploadFileTmp(formData).catch(err => {
		        this.$message({message: err.message, type: 'error'});
		    }).finally(() => {
		        this.uploadLoading = false;
		    });
		    const{state,msg,result} = res.data;
		    if (state == 1 && result) {
		        filePath = result.url;
		    }else{
		        this.$message.error(msg || '上传失败');
		    }			
		    this.$request({
		        url:'/activity/updateSite',
		        method: 'post',
		        params:{
		            path:filePath,
		            buildTime: this.buildTime,
		            ticketPriceId: this.id,
					sessionId:this.data.sessionIds.toString()
		        }
		    })
		        .then(res => {
		            const{state,msg,result} = res.data;
		            if (state == 1) {
		                if(result && result.importErrorDetailVOList && result.importErrorDetailVOList.length > 0){
		                    this.$refs.errorMsgDrawer.show(result);
		                }else{
		                    this.onSuccess();
		                }
		                
		            }else{
		                this.$message.error(msg || '上传失败');
		                this.canSubmit = false;
		            }
		        })
		        .catch(err => {
		            this.canSubmit = false;
		            this.$message({message: err.message, type: 'error'});
		        })
		        .finally(() => {
		            this.btnLoading = false;
		            this.canSubmit = true;
		        });
		},
		beforeUpload(file){
		    const type = this.$utils.getFileType(file.name)
		    const isType = type === 'xls' || type === 'xlsx';
		    if (!isType) {
		        this.$message.error('仅支持xls、xlsx文件格式,请重新选择上传文件!');
		    }
		    return isType;
		},
		onSuccess(){
		    this.$emit('onUpdate');
		    this.close();
		},
		onChange(file){
		    if( file ){
		        this.fileList = [{...file}]
		        this.canSubmit = false;
		    }else{
		        this.canSubmit = true;
		    }
		},
		onRemove(){
		    this.canSubmit = true;
		}
        
        
    },
};
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger, 
::v-deep .el-upload{
    width: 100%;
}
.color-info{
    margin-top: 20px;
}
.el-table{
    margin-bottom: 10px;
}
.from-tip{
    max-width: 420px;
    font-size: 12px;
    b{
        color: $--color-theme;
    }
}
</style>